const PROVIDER_IS_V2 = 'ContentAssistantV2';
const AI_OWNER_IDENTITY = 'postmaster@ai.msging.net';
const CONFIGURATIONS_OWNER_IDENTITY = 'postmaster@configurations.msging.net';
const SUB_VARIABLE_KEY_SEPARATOR = '.';
export class ArtificialIntellingeceConfigurationsParser {
    static parse(resource) {
        const config = {};
        Object.keys(resource).forEach(key => {
            const value = resource[key];
            switch (key) {
                case PROVIDER_IS_V2:
                    config[key] = value == 'True';
                    break;
                default:
                    config[key] = value;
                    break;
            }
        });
        return config;
    }
}
export class ArtificialIntellingeceConfigurationsService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        this.MessagingHubService = MessagingHubService;
    }
    get(owner, caller = undefined, useConfigurationsApplication = false) {
        let uri = `lime://${owner}/configuration`;
        if (caller) {
            uri += `?caller=${caller}`;
        }
        return this.MessagingHubService.sendCommand({
            method: 'get',
            uri: uri,
            to: useConfigurationsApplication ? CONFIGURATIONS_OWNER_IDENTITY : undefined,
        });
    }
    async isV2ConfigurationEnabled(useConfigurationsApplication = false) {
        try {
            const resource = await this.getArtificialIntellingeceConfigurations(useConfigurationsApplication);
            return resource.ContentAssistantV2 ?? false;
        }
        catch {
            return false;
        }
    }
    async getArtificialIntellingeceConfigurations(useConfigurationsApplication = false) {
        const resource = await this.get(AI_OWNER_IDENTITY, undefined, useConfigurationsApplication);
        return ArtificialIntellingeceConfigurationsParser.parse(resource);
    }
}
ArtificialIntellingeceConfigurationsService.$inject = ['MessagingHubService'];
